export default __webpack_public_path__ + "static/media/D.1e698668.svg";